import type { AppRouteRecordRaw } from '@/router/types'

export const recycleBinRoutes: AppRouteRecordRaw[] = [
  {
    path: 'recycleBin',
    name: 'RecycleBin',
    component: () => import('@/views/recycleBin/index.vue'),
    meta: { title: '回收站', keepAlive: true }
  },
  {
    path: 'recycleBinDetail',
    name: 'RecycleBinDetail',
    component: () => import('@/views/recycleBin/recycleBinDetail/index.vue'),
    meta: { title: '回收站客户详情' }
  }
]
